
    import JobViewApplyMixin from '@/components/JobView/Mixins/JobViewApplyMixin';

    export default {
        name: 'JobViewApplyOnsite',

        mixins: [JobViewApplyMixin],
    };
